import React from 'react';
import moment from 'moment';
import GroupPeople from './GroupPeople.jsx';
import { ShowIf } from 'components/utils';
import { Text } from 'components/tt-forms/common';

export default class ListSinglePerson extends React.Component {

  render() {
    let ListNguoiDungDon = '';

    if (this.props.parent.loaiNguoiDungDon && this.props.parent.dataNguoiDungDon) {
      ListNguoiDungDon = this.props.parent.dataNguoiDungDon.map((item, i) => {
        return (
          <div key={i}>
            <div className="group-box">
              <div className="items-form">
                <div className="title">
                  <div className="rows">
                    <div className="col-12">
                      <ShowIf condition={this.props.parent.loaiNguoiDungDon == "CA_NHAN"}>
                        <h3>Người đứng đơn {this.props.parent.dataNguoiDungDon.length > 1 ? i + 1 : ''}</h3>
                      </ShowIf>
                      <ShowIf condition={this.props.parent.loaiNguoiDungDon == "DOAN_DONG_NGUOI" || this.props.parent.loaiNguoiDungDon == "CO_QUAN_TO_CHUC" }>
                        <h3>Người đại diện {this.props.parent.dataNguoiDungDon.length > 1 ? i + 1 : ''}</h3>
                      </ShowIf>
                    </div>
                  </div>
                </div>
                <div className="rows">
                  <Text
                    className="col-input"
                    label="Họ và tên:"
                    value={item.hoVaTen ? item.hoVaTen : ''} />

                  <Text
                    className="col-input"
                    label="Ngày sinh:"
                    value={item.ngaySinh ? moment(item.ngaySinh).format('DD/MM/YYYY') : ''} />

                  <Text
                    className="col-input"
                    label="Số điện thoại:"
                    value={item.soDienThoai || ''} />

                  <Text
                    className="col-input"
                    label="Giới tính:"
                    value={item.gioiTinh ? 'Nam' : 'Nữ'} />
                </div>
              </div>
              <div className="items-form">
                <div className="rows">
                  <Text
                    className="col-input"
                    label="Số CMND/ Hộ chiếu:"
                    value={item.soCMNDHoChieu ? item.soCMNDHoChieu : ''} />
                  <Text
                    className="col-input"
                    label="Ngày cấp:"
                    value={item.ngayCap ? moment(item.ngayCap).format('DD/MM/YYYY') : ''} />
                  <Text
                    className="col-input"
                    label="Nơi cấp:"
                    value={item.noiCapCMNDInfo ? item.noiCapCMNDInfo.ten : ''} />
                  <Text
                    className="col-input"
                    label="Quốc tịch:"
                    value={item.quocTichCongDan ? item.quocTichCongDan.ten : ''} />
                  <Text
                    className="col-input"
                    label="Dân tộc:"
                    value={item.danTocCongDan ? item.danTocCongDan.ten : ''} />
                </div>
              </div>
              <div className="items-form">
                <div className="rows">
                  <Text
                    className="col-input"
                    label="Tỉnh:"
                    value={item.tinhThanhCongDan ? item.tinhThanhCongDan.ten : ''} />
                  <ShowIf condition={item.quanHuyenCongDan != null || item.phuongXaCongDan != null || (item.toThon != '' && item.toThon != null)}>
                    <Text
                      className="col-input"
                      label="Quận/Huyện:"
                      value={item.quanHuyenCongDan ? item.quanHuyenCongDan.ten : ''} />
                    <Text
                      className="col-input"
                      label="Phường/Xã:"
                      value={item.phuongXaCongDan ? item.phuongXaCongDan.ten : ''} />
                  </ShowIf>
                  <Text
                  className="col-w40"
                  label="Địa chỉ (Số nhà /Tên đường /Tổ, thôn):"
                  value={item.diaChi ? item.diaChi : ''} />
                </div>
              </div>
            </div>
          </div>
        )
      });

    } else {
      ListNguoiDungDon = (<div></div>)
    }

    return (
      <div>
        {ListNguoiDungDon}
        <ShowIf condition={this.props.parent.loaiNguoiDungDon == "DOAN_DONG_NGUOI"}>
          <GroupPeople doanDiCung={this.props.parent.dataDoanDiCung} />
        </ShowIf>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/letter-information/letter-detail/ListSinglePerson.jsx